import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';
import { FolderType } from '@models';

@NgModule()
export class EnvironmentMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: EnvironmentMetaModule,
            providers: [
                providePageMeta({
                    title: 'Environments',
                    translationKey: 'page_environments',
                    routerLink: '/environments',
                    icon: 'cubes',
                    permission: 'Environments.View',
                    type: 'SubMenu',
                    parentRoute: '/robots',
                    category: PageCategory.Tenant,
                    scope: PageScope.Folder,
                    folderTypeDependency: FolderType.Classic,
                }),
            ],
        };
    }
}
